import React, { createContext, useState, useMemo } from 'react';

const AirportContext = createContext(null);

function AirportContextProvider(props) {
  const [airport, setAirport] = useState(() => {
    // Initialize from localStorage only once (lazy initialization)
    const stored = localStorage.getItem('current_airport');
    return stored ? JSON.parse(stored) : null;
  });

  // Memoize the context value to prevent unnecessary re-renders
  const value = useMemo(
    () => ({
      airport,
      setAirport,
    }),
    [airport, setAirport],
  );

  return <AirportContext.Provider value={value}>{props.children}</AirportContext.Provider>;
}

export { AirportContextProvider, AirportContext as airportContext };
